import React, { useEffect } from "react";
import http from "../services/httpService";
import SearchBar from "material-ui-search-bar";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContentText,
  DialogTitle,
  TablePagination,
} from "@material-ui/core";
import { useState } from "react";
import {
  createAdviseRequestPath,
  getDateTime,
  searchFilter,
} from "../utils/varialbles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import { CancelOutlined } from "@material-ui/icons";

export default function Cdtadvicepending() {
  const history = useHistory();
  const [totalRowCount, setTotalRowCount] = useState("");
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);

  let columns = [
    { id: "userid", label: "User Id", minWidth: 150 },
    { id: "reqid", label: "Id", minWidth: 150 },
    { id: "mobile", label: "Mobile No", minWidth: 150 },
    { id: "name", label: "Name", minWidth: 150 },
    { id: "emp", label: "Employee", minWidth: 150 },
    { id: "freq", label: "Frequency", minWidth: 150 },
    { id: "date", label: "Date", minWidth: 150, type: "date" },
    { id: "efg", label: "EFG", minWidth: 150 },
    { id: "elss", label: "ELSS", minWidth: 150 },
    { id: "country", label: "Country", minWidth: 150 },
    { id: "amount", label: "Amount", minWidth: 150 },
    { id: "comment", label: "Comment", minWidth: 150 },
    localStorage.getItem("empMail") === "dipak@savart.com" && {
      id: "",
      label: "Delete",
      minWidth: 150,
    },
  ];

  // {
  //   localStorage.getItem("empMail") === "dipak@savart.com"
  //     ? (columns = [
  //         { id: "userid", label: "User Id", minWidth: 150 },
  //         { id: "reqid", label: "Id", minWidth: 150 },
  //         { id: "mobile", label: "Mobile No", minWidth: 150 },
  //         { id: "name", label: "Name", minWidth: 150 },
  //         { id: "emp", label: "Employee", minWidth: 150 },
  //         { id: "freq", label: "Frequency", minWidth: 150 },
  //         { id: "date", label: "Date", minWidth: 150, type: "date" },
  //         { id: "efg", label: "EFG", minWidth: 150 },
  //         { id: "elss", label: "ELSS", minWidth: 150 },
  //         { id: "country", label: "Country", minWidth: 150 },
  //         { id: "amount", label: "Amount", minWidth: 150 },
  //         { id: "comment", label: "Comment", minWidth: 150 },
  //         { id: "", label: "Delete", minWidth: 150 },
  //       ])
  //     : (columns = [
  //         { id: "userid", label: "User Id", minWidth: 150 },
  //         { id: "reqid", label: "Id", minWidth: 150 },
  //         { id: "mobile", label: "Mobile No", minWidth: 150 },
  //         { id: "name", label: "Name", minWidth: 150 },
  //         { id: "emp", label: "Employee", minWidth: 150 },
  //         { id: "freq", label: "Frequency", minWidth: 150 },
  //         { id: "date", label: "Date", minWidth: 150, type: "date" },
  //         { id: "efg", label: "EFG", minWidth: 150 },
  //         { id: "elss", label: "ELSS", minWidth: 150 },
  //         { id: "country", label: "Country", minWidth: 150 },
  //         { id: "amount", label: "Amount", minWidth: 150 },
  //         { id: "comment", label: "Comment", minWidth: 150 },
  //       ]);
  // }

  const getPaginationURL = (url, newQuery) => {
    console.log(newQuery, "sedrftgyhu");
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&search=${query}`;
    } else {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}&page_type=P`;
    }
  };

  const getData = () => {
    toast.loading("Please wait");
    http
      .get(getPaginationURL(`/CDTinvreqs`))
      .then((res) => {
        toast.dismiss();

        if (res.data.statusCode === 0) {
          setRows(res.data.Data);
          const tempdata = res.data.Data;
          setOriginalRows(tempdata);
          setTotalRowCount(res.data.totalRowCount);
        } else {
          setRows([]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };

  const viewPendingDetails = (row) => {
    history.push({
      pathname: createAdviseRequestPath,
      state: row,
      string: "cdtAdvices",
    });
  };

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, searched]);

  const [openDelete, setOpenDelete] = useState(false);
  const [openDeleteId, setOpenDeleteId] = useState("");
  const [openDeleteCustId, setOpenDeleteCustId] = useState("");
  const [getDelComment, setDelComment] = useState("");

  const deletePendingAdvice = (e, row) => {
    console.log(row);
    setOpenDelete(true);
    setOpenDeleteId(row.reqid);
    setOpenDeleteCustId(row.cust_id);
  };

  const handleDelComment = (e) => {
    setDelComment(e.target.value);
  };

  const deletePendingRequest = () => {
    if (getDelComment) {
      http
        .post(`delete-advise`, {
          req_id: openDeleteId,
          cust_id: openDeleteCustId,
          comment: getDelComment,
        })
        .then((res) => {
          console.log(res);
          if (res.data.statusCode === 0) {
            toast.success(res.data.Data);
            setOpenDelete(false);
            getData();
          } else {
            toast.error(res.data.Data);
            setOpenDelete(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toast.error("Please add comments");
    }
  };

  return (
    <div>
      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        className={"mt30"}
      />
      <TablePagination
        rowsPerPageOptions={[10, 50, 100, 1500]}
        component="div"
        count={totalRowCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((item, index) => {
                return <TableCell>{item.label}</TableCell>;
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length !== 0 ? (
              rows.map((row, index) => {
                return (
                  <TableRow
                    onDoubleClick={() =>
                      localStorage.getItem("empRole") === "Research Team" ||
                      localStorage.getItem("empRole") === "CEO" ||
                      localStorage.getItem("empRole") === "CTO"
                        ? viewPendingDetails(row)
                        : ""
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {columns.map((cols, index) => {
                      const value = row[cols.id];
                      console.log(value);
                      return (
                        <TableCell>
                          {cols.type === "date" ? (
                            getDateTime(value)
                          ) : value ? (
                            value ? (
                              value
                            ) : (
                              "N/A"
                            )
                          ) : cols.label &&
                            cols.label === "Delete" &&
                            value === undefined &&
                            localStorage.getItem("empMail") ===
                              "dipak@savart.com" ? (
                            <Button>Delete</Button>
                          ) : value === undefined ? (
                            " "
                          ) : (
                            "N/A  "
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })
            ) : (
              <p
                style={{
                  textAlign: "center",
                }}
              >
                No data available
              </p>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {openDelete === true && (
        <Dialog open={openDelete}>
          <div style={{ textAlign: "right", padding: "10px 10px 10px 0px" }}>
            <Button>
              <CancelOutlined onClick={setOpenDelete} />
            </Button>
          </div>
          <DialogContentText style={{ padding: "5px 20px" }}>
            Are you sure you want to delete?
            <br />
            <br />
            <label>
              Comments <span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <textarea
              onChange={handleDelComment}
              placeholder="comments"
              cols={30}
              rows={6}
            ></textarea>
          </DialogContentText>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={deletePendingRequest}
            >
              Yes
            </Button>
            <Button color="primary" variant="contained" onClick={setOpenDelete}>
              No
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
}
